var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6022 20.9528L16.6593 13.9491C17.5066 12.6185 17.9804 11.0846 18.0312 9.50797C18.082 7.93135 17.7079 6.37009 16.9481 4.98773C16.1883 3.60536 15.0707 2.45275 13.7124 1.65065C12.3541 0.848548 10.8051 0.426464 9.22772 0.428611C8.07446 0.421965 6.9314 0.644668 5.86499 1.08377C4.79858 1.52287 3.83011 2.16961 3.01591 2.98638C2.18425 3.79267 1.52375 4.75841 1.07391 5.82583C0.624074 6.89326 0.394144 8.04045 0.397872 9.19879C0.397872 11.5739 1.31153 13.7665 3.01651 15.4715C4.43818 16.8849 6.30011 17.7702 8.29378 17.9807C10.2874 18.1911 12.2932 17.7141 13.9786 16.6286L20.9197 23.5715L23.6022 20.9528ZM5.08792 13.3398C4.54733 12.8004 4.11844 12.1596 3.82581 11.4542C3.53318 10.7488 3.38255 9.99261 3.38255 9.22892C3.38255 8.46523 3.53318 7.70904 3.82581 7.00364C4.11844 6.29824 4.54733 5.65748 5.08792 5.11805C6.18419 3.96091 7.64568 3.41308 9.22952 3.41308C10.8134 3.41308 12.2749 3.96091 13.3711 5.11805C14.4614 6.21648 15.0707 7.70302 15.0649 9.25066C15.0591 10.7983 14.4388 12.2803 13.3404 13.3705C12.242 14.4608 10.7554 15.0701 9.20779 15.0643C7.66015 15.0585 6.17819 14.4382 5.08792 13.3398Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_47"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.cc5b99101e3fdb56566a2773ef70d95e.svg";
export { ForwardRef as ReactComponent };